import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentaryProofDCMService } from '@app/core/services/data-control-manager/documentary-proof-dcm.service';
import { DocumentaryProofDCM, DocumentaryProofFile } from '@app/core/services/data-control-manager/model/documentary-proof-dcm.model';
import { DocumentaryProofStatusEnum } from '@app/core/services/data-control-manager/model/enum/documentary-proof-status.enum';
import { NotificationService } from '@app/core/services/util/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ap-documentary-proof-card',
    templateUrl: './documentary-proof-card.component.html',
    styleUrls: ['./documentary-proof-card.component.css'],
    standalone: false
})
export class DocumentaryProofCardComponent implements OnInit {

  @Input() index: number;
  @Input() documentaryProof: DocumentaryProofDCM;
  @Input() documentSelected: DocumentaryProofFile;

  @Output() select: EventEmitter<any> = new EventEmitter();
  @Output() onChangeDocument: EventEmitter<any> = new EventEmitter();
  DocumentaryProofStatusEnum = DocumentaryProofStatusEnum;

  checkValues = { check: false, close: false };

  constructor(private documentaryProofDCMService: DocumentaryProofDCMService, private notificationService: NotificationService, private translateService: TranslateService) {}

  ngOnInit(): void {
    this.initStatusButton();
  }

  /* SELECT DOC PROOF */
  isSelectedCheck(index) {
    if (index === 1) {
      return this.checkValues.close
    } else if (index === 2) {
      return this.checkValues.check;
    }
    return false;
  }

  selectCheckDocProof(index) {
    // click on refuse else click on validate
    if (index === 1) {
      this.checkValues.close = !this.checkValues.close;
      this.checkValues.check = !this.checkValues.close;
    } else if (index === 2) {
      this.checkValues.check = !this.checkValues.check;
      this.checkValues.close = !this.checkValues.check;
    }

    if (this.checkValues.check && !this.checkValues.close) {
      this.documentaryProofDCMService.validateDocumentaryProof(this.documentaryProof.documentaryProofId, null).subscribe({
        next: _res => {
          this.documentaryProof = _res;
          this.onChangeDocument.emit(this.documentaryProof);
          this.notificationService.notify('success', this.translateService.instant('SHARED.DOCUMENTARY_PROOF_CARD.TOAST.VALIDATE.SUCCESS'));
        },
        error: _err => {
          this.initStatusButton();
          this.notificationService.notify('error', this.translateService.instant('SHARED.DOCUMENTARY_PROOF_CARD.TOAST.VALIDATE.ERROR'));
        }
      });
    } else if (!this.checkValues.check && this.checkValues.close) {
      this.documentaryProofDCMService.refuseDocumentaryProof(this.documentaryProof.documentaryProofId, null).subscribe({
        next: _res => {
          this.documentaryProof = _res;
          this.onChangeDocument.emit(this.documentaryProof);
          this.notificationService.notify('success', this.translateService.instant('SHARED.DOCUMENTARY_PROOF_CARD.TOAST.REFUSE.SUCCESS'));
        },
        error: _err => {
          this.initStatusButton();
          this.notificationService.notify('error', this.translateService.instant('SHARED.DOCUMENTARY_PROOF_CARD.TOAST.REFUSE.ERROR'))
        }
      });
    }

  }

  /* SELECT DOC PROOF FILES */
  isSelectedFile(documentaryProofFileId: number) {
    if (this.documentSelected) {
      return this.documentSelected.documentaryProofFileId === documentaryProofFileId;
    }
    return false;
  }

  selectDocFile(documentaryProofFileId: number, indexFile: number) {
    if (this.documentSelected?.documentaryProofFileId === documentaryProofFileId) {
      this.select.emit(null);
    } else {
      const index = this.index;
      this.select.emit({documentaryProofFileId, documentaryProofId: this.documentaryProof.documentaryProofId, index, indexFile});
    }
  }

  private initStatusButton() {
    switch(this.documentaryProof.status) {
      case DocumentaryProofStatusEnum.VALIDATED:
        this.checkValues = { check: true, close: false };
        break;
      case DocumentaryProofStatusEnum.REFUSED:
        this.checkValues = { check: false, close: true };
        break;
      default:
        this.checkValues = { check: false, close: false };
    }
  }
}
